import { useSelector } from 'react-redux';

const types = ['express', 'single'];

const useTypeItems = () => {
  const locale = useSelector(state => state.locale.locale.sportHistory);

  const items = types.map(v => ({
    value: v,
    key: v,
    renderElement: locale.type?.[v] ?? v,
    selectedRenderElement: locale.type?.[v] ?? v,
    active: false,
  }));

  return [
    {
      value: 'all',
      key: 'all',
      renderElement: locale.all,
      selectedRenderElement: locale.all,
      active: true,
    },
  ].concat(items);
};

export default useTypeItems;
